export enum QuestionURLPattern {
    Pattern1 = "^(.+)/(.+)/([0-9])/(.+)$",
    Pattern2 = "^(.+)/(.+)_(.+).htm$",
    Pattern3 = "^(.+)/(.+)/(.+)/(.+)$",
    Pattern4 = "^(.+)$",

    // Pattern4_1 = "^[0-9]{2}-(.+)-(.+)",
    Pattern4_1 = "^([0-9]*)-(.+)-(.+)",

    //PackageURL
    PackagePattern1 = "^[0-9]+",
    PackagePattern2 = "^[a-z-]+",

    htmlTagPattern = "<[^>]*>",


    //blog Url Pattern
    category = "^(.+)/(.+)",
}